module.exports = __webpack_public_path__ + "img/cylinder_inner_gear.prt.68c51ce0.jpg";